class StyledScroll extends HTMLElement {
  activeIndex = 0;

  activeStyle = '';
  inactiveStyle = '';

  constructor() {
    super();

    const activeIndex = this.dataset.activeIndex;
    if (!activeIndex) throw new Error('styled-scroll-element missing data-active-index');
    this.activeIndex = parseInt(activeIndex, 10);

    this.activeStyle = this.dataset.activeStyle;
    this.inactiveStyle = this.dataset.inactiveStyle;

    const containerSelector = this.dataset.containerSelector;
    if (!containerSelector) throw new Error('dot-scroll-element missing data-container-selector');

    const container = document.querySelector(containerSelector);
    container.addEventListener('scroll', this.onScroll.bind(this));
  }

  onScroll(e) {
    const newIndex = Math.round(
      e.currentTarget.scrollLeft / (e.currentTarget.scrollWidth / e.currentTarget.children.length),
    );

    if (newIndex === this.activeIndex) {
      this.style = this.activeStyle;
    } else {
      this.style = this.inactiveStyle;
    }
  }
}

customElements.define('styled-scroll-element', StyledScroll);
